import React, { useState, useCallback } from 'react';
import { ContactSupportModal } from 'components';
import {
  selectContactSupportFlag,
  selectSupportReqSubmitting,
  selectSupportRes
} from 'redux/user/selector';
import { useDispatch, useSelector } from 'react-redux';
import SupportReqSuccess from 'components/contactSupportModal/supportReqSuccess';
// Temporary block - need to delete after Helix enabled
import RemedyForceSupportReqSuccess from 'components/remedyForceModal/supportReqSuccess';
// Temporary block
import { Button, HeaderMenuButton, Link } from 'carbon-components-react';
import {
  HeaderName,
  SideNav,
  SideNavItems,
  SideNavLink
} from 'carbon-components-react/lib/components/UIShell';
import { setAppLoginType, setHeaderPanelExpand } from 'redux/app/actions';
import {
  selectIsAuthenticated,
  selectScreenSize
} from 'redux/session/selectors';
import { fetchAuthRequest } from 'redux/auth/action';
import {
  APP_URL,
  AUTH_TYPE,
  USERSROLE,
  SCREEN_SIZE,
  DBYD_1100_URL
} from 'types';
import { contactSupportFlag } from 'redux/user/actions';
import Services from 'services';
import { useHistory } from 'react-router-dom';
import { selectAppUserRole } from 'redux/app/selectors';
import { Announcements } from 'components';
import { ReactComponent as LogoBYDABig } from 'assets/images/byda/ui-custom-logos-48-byda-logo.svg';
import { ReactComponent as LogoBYDASmall } from 'assets/images/byda/ui-custom-logos-byda-symbol-box.svg';

export interface PageProps {
  hideAnnouncements?: boolean;
  enableHeaderGlobalBar?: boolean;
  pageClassName?: string;
  isSideNavExpanded?: boolean;
  hamburgerMenuHandler?: boolean;
  bodyFooterIcon?: any;
  isOTPActivated?: boolean;
  showOTPNotification?: boolean;
  showTopLinks?: boolean;
  hideMenuAndLinks?: boolean;
}

const smallerScreen = [SCREEN_SIZE.MD, SCREEN_SIZE.SM];
/**
 * FULL HEADER, LEFT AND RIGHT PANEL LAYOUT (3 COLUMN)
 */
export const GenericPageLayout: React.FC<PageProps> = (props: any) => {
  const {
    pageClassName,
    bodyFooterIcon,
    hideAnnouncements = false,
    isOTPActivated = false,
    showOTPNotification = false,
    showTopLinks = true,
    hideMenuAndLinks = false
  } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const userRole: string = useSelector(selectAppUserRole);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const supportRes: any = useSelector(selectSupportRes);
  const submitting: boolean = useSelector(selectSupportReqSubmitting);
  const isContactSupportOpen = useSelector(selectContactSupportFlag);
  const screenSize = useSelector(selectScreenSize);

  const [isSideNavExpanded, setIsSideNavExpanded] = useState<boolean>(false);

  const hamburgerMenuHandler = () => {
    setIsSideNavExpanded(!isSideNavExpanded);
  };

  const handleSSO = useCallback(() => {
    dispatch(setAppLoginType(AUTH_TYPE.SSO_LOGIN));
    dispatch(fetchAuthRequest({ context: AUTH_TYPE.SSO_LOGIN }));
  }, [dispatch]);

  const handleOpenContactSupport = useCallback(() => {
    dispatch(contactSupportFlag(true));
    dispatch(setHeaderPanelExpand({ panel: 'account', isOpen: false }));
  }, [dispatch]);

  const handleAboutOTP = () => {
    window.open(
      'https://help.byda.com.au/article/temporary-passcodes/'
    );
  };

  const renderLogoBurgerMenu = () => (
    <>
      {screenSize && smallerScreen.includes(screenSize) && !hideMenuAndLinks ? (
        <HeaderMenuButton
          className="burgerMenuButton bx--col-md-0 bx--col-lg-0"
          aria-label="Open menu"
          isCollapsible
          onClick={() => hamburgerMenuHandler()}
          isActive={!!isSideNavExpanded}
        />
      ) : null}
      <HeaderName className="generic-page--logo" prefix="">
        {screenSize && screenSize === SCREEN_SIZE.SM ? (
          <LogoBYDASmall className="header-logo-img" />
        ) : (
          <LogoBYDABig className="header-logo-img" />
        )}
      </HeaderName>
    </>
  );

  const renderAuthenticatedLinks = () => (
    <div className="generic-page--header-links">
      <Link onClick={() => history.push(APP_URL.DASHBOARD)}>Dashboard</Link>
      <Link onClick={() => history.push(APP_URL.LODGE_NEW_ENQUIRY)}>
        Lodge new enquiry
      </Link>
      <span>
        <Link href={DBYD_1100_URL.HELP} target="_blank">
          Help
        </Link>{' '}
        | <Link onClick={() => handleOpenContactSupport()}>Contact us</Link>
      </span>
    </div>
  );

  const renderUnAuthLinks = () => (
    <div className="generic-page--header-linkTextWrap">
      <p>
        <Button
          className="custom-button-link"
          kind="ghost"
          onClick={handleSSO}
          disabled={isOTPActivated}
        >
          Sign in
        </Button>{' '}
        to lodge or track enquiries
      </p>
      <p>
        No account?{' '}
        <Button
          className="custom-button-link"
          kind="ghost"
          disabled={isOTPActivated}
          onClick={() => Services.auth.signupWithSSOService()}
        >
          Register free here
        </Button>
      </p>
      <p>
        <Button
          className="custom-button-link"
          kind="ghost"
          onClick={() => window.open(DBYD_1100_URL.HELP, '_blank')}
        >
          Help
        </Button>{' '}
        |{' '}
        <Button
          className="custom-button-link"
          kind="ghost"
          onClick={() => handleOpenContactSupport()}
        >
          Contact us
        </Button>
      </p>
    </div>
  );

  const renderOTPNotification = () => (
    <div className="generic-page--otp-notification">
      <div className="generic-page--otp-description">
        There’s a small problem with the normal sign in page but to keep you
        going we are using{' '}
        <span className="generic-page--otp-code">temporary passcodes</span>{' '}
        today. Enter your registered email to get one sent to you.
        <div onClick={handleAboutOTP} className="generic-page--otp-link">
          About temporary passcodes.
        </div>
      </div>
    </div>
  );

  return props.children ? (
    <React.Fragment>
      <header className="generic-page--header">
        {renderLogoBurgerMenu()}
        {showTopLinks &&
          (!isAuthenticated ? (
            <>
              {screenSize && !smallerScreen.includes(screenSize) ? (
                renderUnAuthLinks()
              ) : (
                <>
                  {!hideMenuAndLinks && (
                    <Button
                      className="custom-button-link"
                      kind="ghost"
                      onClick={handleSSO}
                      disabled={isOTPActivated}
                    >
                      Sign in
                    </Button>
                  )}
                </>
              )}
            </>
          ) : screenSize && !smallerScreen.includes(screenSize) ? (
            renderAuthenticatedLinks()
          ) : (
            <Button
              className="custom-button-link"
              kind="ghost"
              onClick={() => history.push(APP_URL.LODGE_NEW_ENQUIRY)}
            >
              New enquiry
            </Button>
          ))}

        {isContactSupportOpen && <ContactSupportModal />}
        {screenSize &&
        smallerScreen.includes(screenSize) &&
        isSideNavExpanded ? (
          <SideNav
            isFixedNav
            expanded={isSideNavExpanded}
            isChildOfHeader={true}
            aria-label="Side navigation"
            isRail
            defaultExpanded={false}
            className={`leftHandSideNav ${isSideNavExpanded ? 'expanded' : ''}`}
            data-testid="leftHandSideNav"
          >
            <SideNavItems isSideNavExpanded={true}>
              {isAuthenticated ? (
                <SideNavLink
                  onClick={() => history.push(`${APP_URL.DASHBOARD}`)}
                >
                  Dashboard
                </SideNavLink>
              ) : (
                <SideNavLink
                  onClick={() => Services.auth.signupWithSSOService()}
                >
                  Register free
                </SideNavLink>
              )}
              <SideNavLink onClick={() => handleOpenContactSupport()}>
                Contact us
              </SideNavLink>

              <SideNavLink href={DBYD_1100_URL.TERMS_OF_USE} target="_blank">
                Terms
              </SideNavLink>
              <SideNavLink href={DBYD_1100_URL.PRIVACY_POLICY} target="_blank">
                Privacy
              </SideNavLink>
              <SideNavLink href={DBYD_1100_URL.HELP} target="_blank">
                Website help
              </SideNavLink>
              <SideNavLink
                className="emergency--link"
                onClick={() => history.push(`${APP_URL.EMERGENCY}`)}
              >
                Emergency
              </SideNavLink>
            </SideNavItems>
          </SideNav>
        ) : null}
        {!hideAnnouncements && <Announcements />}
      </header>
      {isOTPActivated && showOTPNotification && renderOTPNotification()}
      <main
        className={`generic-page--main ${pageClassName ? pageClassName : ''}`}
      >
        <div className="generic-page--main-top">{props.children}</div>
        {bodyFooterIcon ? (
          <div className="generic-page--main-bottom-icon">
            {typeof bodyFooterIcon === 'object' ? (
              <>{bodyFooterIcon}</>
            ) : (
              <img src={bodyFooterIcon} alt="" width="112" height="112" />
            )}
          </div>
        ) : null}
      </main>
      <footer className="generic-page--footer">
        {screenSize && screenSize !== SCREEN_SIZE.SM && (
          <>
            <Link href={DBYD_1100_URL.TERMS_OF_USE} target="_blank">
              Terms
            </Link>
            |
            <Link href={DBYD_1100_URL.PRIVACY_POLICY} target="_blank">
              Privacy
            </Link>
            |
            <Link
              onClick={() => history.push(APP_URL.EMERGENCY)}
              className="emergency--link"
            >
              Emergency
            </Link>
          </>
        )}
      </footer>
      {!submitting && supportRes ? (
        <>
          {process.env.REACT_APP_REMEDY_FORCE_ENABLED === 'true' ? (
            <RemedyForceSupportReqSuccess
              unauthenticated={userRole === USERSROLE.OTHER}
            />
          ) : (
            <SupportReqSuccess unauthenticated={userRole === USERSROLE.OTHER} />
          )}
        </>
      ) : null}
    </React.Fragment>
  ) : null;
};
